export enum EquipmentRequestBillableEnum {
  yes = 'Billable',
  no = 'Non Billable',
  billAsCOE = 'COE',
}
